import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import aboutHome from '../views/about/Home.vue'
import shophome from '../views/shop/Home.vue'
Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'Home',
        component: () =>
            import ('@/views/Index.vue'),
        // meta: { authc: true }
    },

    {
        path: '/page01',
        name: 'Home',
        component: () =>
            import ('@/views/test/page01.vue'),
    },

    {
        path: '/page02',
        name: 'Home',
        component: () =>
            import ('@/views/test/page02.vue'),
    },

    {
        path: '/wechat',
        name: 'Home',
        component: Home,
        meta: { authc: true }
    },

    {
        path: '/home',
        name: 'Home',
        component: Home,
        meta: { authc: true }
    },

    {
        path: '/jisao',
        name: 'jisao',

        component: () =>
            import ('../views/jisao/Index.vue'),
        meta: { authc: true },
    },
    {
        path: '/shopjisao/:id',
        name: 'shopjisao',

        component: () =>
            import ('../views/jisao/Jisao.vue'),
        meta: { authc: true },
    },
    {
        path: '/jisao/list/',
        name: 'jisaoList',
        component: () =>
            import ('../views/jisao/List.vue'),
    },

    {
        path: '/jisao/Detail:id',
        name: 'detail',

        component: () =>
            import ('../views/jisao/Detail.vue'),
        meta: { authc: true },
    },
    {
        path: '/about',
        name: 'about',
        component: () =>
            import ('../views/about/Index.vue'),
        redirect: 'abouthome',
        children: [{
                path: '/abouthome',
                name: 'abouthome',
                component: aboutHome,
                meta: { authc: true },
            },
            {
                path: '/news',
                name: 'news',
                component: () =>
                    import ('../views/about/news/Index.vue'),
                meta: { authc: true },
            },
            {
                path: '/search/:keyword',
                name: 'search',
                component: () =>
                    import ('../views/about/news/Search.vue'),
                meta: { authc: true },
            },
            {
                path: '/newsDetail/:class/:id',
                name: 'newsDetail',
                component: () =>
                    import ('../views/about/news/Detail.vue'),
                meta: { authc: true },
            },
            {
                path: '/beixing',
                name: 'beixing',
                component: () =>
                    import ('../views/about/beixing/Index.vue'),
                meta: { authc: true },
            },
            {
                path: '/bxDetail/:id',
                name: 'bxDetail',
                component: () =>
                    import ('../views/about/beixing/Detail.vue'),
                meta: { authc: true },
            },
            {
                path: '/guanjia',
                name: 'guanjia',
                component: () =>
                    import ('../views/about/Guanjia.vue'),
                meta: { authc: true },
            },

            {
                path: '/myyq',
                name: 'myyq',
                component: () =>
                    import ('../views/about/Myyq.vue'),
                meta: { authc: true },
            },
            {
                path: '/aboutus',
                name: 'aboutus',
                component: () =>
                    import ('../views/about/About.vue'),
                meta: { authc: true },
            },
            {
                path: '/byyw',
                name: 'byyw',
                component: () =>
                    import ('../views/about/Byyw.vue'),
                meta: { authc: true },
            },
            {
                path: '/jsfw/:type',
                name: 'jsfw',
                component: () =>
                    import ('../views/about/Service.vue'),
                meta: { authc: true },
            },
            {
                path: '/sqqy',
                name: 'sqqy',
                component: () =>
                    import ('../views/about/Sqqy.vue'),
                meta: { authc: true },
            },
            {
                path: '/jdz',
                name: 'jdz',
                component: () =>
                    import ('../views/about/Jdz.vue'),
                meta: { authc: true },
            },
        ],
    },
    {
        path: '/shop',
        name: 'shop',
        component: () =>
            import ('../views/shop/Index.vue'),
        redirect: 'shophome',
        children: [{
                path: '/shophome',
                name: 'shophome',
                component: shophome,
                meta: { authc: true }
            },
            {
                path: '/my',
                name: 'my',
                component: () =>
                    import ('../views/shop/my/Index.vue'),
                meta: { authc: true }
            },
            {
                path: '/shop/services',
                name: 'services',
                component: () =>
                    import ('../views/shop/Service.vue'),
            },
            {
                path: '/shop/tsjy',
                name: 'tsjy',
                component: () =>
                    import ('../views/shop/Tsjy.vue'),
                meta: { authc: true }
            },
        ],
    },
    {
        path: '/shop/list',
        name: 'shoplist',
        component: () =>
            import ('../views/shop/List.vue'),
        meta: { authc: true }
    },
    {
        path: '/shop/detail/:id',
        name: 'shopdetail',
        component: () =>
            import ('../views/shop/Detail.vue'),
        meta: { authc: true }
    },

    {
        path: '/shop/orders/:type/:id/',
        name: 'orderDetail',
        component: () =>
            import ('../views/shop/my/Order_detail.vue'),
        meta: { authc: true }
    },
    {
        path: '/shop/fuwu/:type/:id/',
        name: 'fuwuDetail',
        component: () =>
            import ('../views/shop/my/Fuwu_detail.vue'),
        meta: { authc: true }
    },
    {
        path: '/shop/fuwu/:type',
        name: 'fuwu',
        component: () =>
            import ('../views/shop/my/Fuwu.vue'),
        meta: { authc: true }
    },
    {
        path: '/shop/cart',
        name: 'shopcart',
        component: () =>
            import ('../views/shop/Cart.vue'),
        meta: { authc: true }
    },
    {
        path: '/shop/orders/:type',
        name: 'orders',
        component: () =>
            import ('../views/shop/my/Orders.vue'),
        meta: { authc: true }
    },
    {
        path: '/shop/cartpay',
        name: 'shopcartpay',
        component: () =>
            import ('../views/shop/Cartpay.vue'),
        meta: { authc: true }
    },
    {
        path: '/shop/payok',
        name: 'shopcartpay1',
        component: () =>
            import ('../views/shop/Payok.vue'),
        meta: { authc: true }
    },
    {
        path: '/shop/yyjs',
        name: 'yyjs',
        component: () =>
            import ('../views/shop/Yyjs.vue'),
    },
    {
        path: '/shop/yyjsgw',
        name: 'yyjsgw',
        component: () =>
            import ('../views/shop/Yyjsgw.vue'),
        meta: { authc: true }
    },
    {
        path: '/shop/glf',
        name: 'glf',
        component: () =>
            import ('../views/shop/Glf.vue'),
        meta: { authc: true }
    },
    {
        path: '/shop/gmdj',
        name: 'gmdj',
        component: () =>
            import ('../views/shop/Gmdj.vue'),
        meta: { authc: true }
    },
    {
        path: '/shop/gmdjgw',
        name: 'gmdjgw',
        component: () =>
            import ('../views/shop/Gmdjgw.vue'),
        meta: { authc: true }
    },
    {
        path: '/shop/zxbx',
        name: 'zxbx',
        component: () =>
            import ('../views/shop/Zxbx.vue'),
    },
    {
        path: '/shop/phzb',
        name: 'phzb',
        component: () =>
            import ('../views/shop/Phzb.vue'),
        meta: { authc: true }
    },
    {
        path: '/shop/phzbdetail',
        name: 'phzbdetail',
        component: () =>
            import ('../views/shop/Phzbdetail.vue'),
        meta: { authc: true }
    },
    {
        path: '/shop/phzbcart',
        name: 'phzbcart',
        component: () =>
            import ('../views/shop/Phzbcart.vue'),
        meta: { authc: true }
    },
    {
        path: '/shop/ydfw',
        name: 'ydfw',
        component: () =>
            import ('../views/shop/Ydfw.vue'),
        meta: { authc: true }
    },
    {
        path: '/shop/ydfwcart',
        name: 'ydfwcart',
        component: () =>
            import ('../views/shop/Ydfwcart.vue'),
        meta: { authc: true }
    },
    {
        path: '/shop/tsdetail',
        name: 'shoptsdetail',
        component: () =>
            import ('../views/shop/Tsjydetail.vue'),
        meta: { authc: true }
    },
    {
        path: '/shop/tsjysub',
        name: 'shoptsjysub',
        component: () =>
            import ('../views/shop/Tsjysub.vue'),
        meta: { authc: true }
    },
    {
        path: '/shop/favorites',
        name: 'favorites',
        component: () =>
            import ('../views/shop/my/Favorites.vue'),
        meta: { authc: true }
    },
    {
        path: '/shop/mycoupon',
        name: 'mycoupon',
        component: () =>
            import ('../views/shop/my/Coupon.vue'),
        meta: { authc: true }
    },

    {
        path: '/shop/coupon',
        name: 'couponlist',
        component: () =>
            import ('../views/shop/Coupon.vue'),
        meta: { authc: true }
    },
    {
        path: '/shop/myexpire',
        name: 'myexpire',
        component: () =>
            import ('../views/shop/my/Expire.vue'),
        meta: { authc: true }
    },

    {
        path: '/jnt',
        name: 'jnt',
        component: () =>
            import ('../views/jnt/Index.vue'),
        redirect: 'jnt/home',
        children: [{
            path: '/jnt/home',
            name: 'jnthome',
            component: () =>
                import ('../views/jnt/Home.vue'),
            meta: { authc: true }
        }, ],
    },
    {
        path: '/jnt/detail/:type/:id',
        name: 'jntdetail',
        component: () =>
            import ('../views/jnt/Detail.vue'),
        redirect: '/jnt/mourn/:type/:id',
        children: [{
                path: '/jnt/muqu/:type/:id',
                name: 'mournmuqu',
                component: () =>
                    import ('../views/jnt/Muqu.vue'),
                meta: { authc: true }
            },
            {
                path: '/jnt/mourn/:type/:id',
                name: 'mourn',
                component: () =>
                    import ('../views/jnt/Mourn.vue'),
                meta: { authc: true }
            },
        ],
    },

    {
        path: '/jnt/history',
        name: 'history',
        component: () =>
            import ('../views/jnt/History.vue'),
        meta: { authc: true }
    },
    {
        path: '/jnt/friends/:id',
        name: 'friends',
        component: () =>
            import ('../views/jnt/Friends.vue'),
        meta: { authc: true }
    },
    {
        path: '/jnt/complain',
        name: 'complain',
        component: () =>
            import ('../views/jnt/Complain.vue'),
        meta: { authc: true }
    },
    {
        path: '/jnt/set/:id',
        name: 'set',
        component: () =>
            import ('../views/jnt/center/Set.vue'),
        meta: { authc: true }
    },
    {
        path: '/jnt/background/:type/:id',
        name: 'background',
        component: () =>
            import ('../views/jnt/center/Background.vue'),
        meta: { authc: true }
    },
    {
        path: '/jnt/music/:id',
        name: 'music',
        component: () =>
            import ('../views/jnt/center/Music.vue'),
        meta: { authc: true }
    },
    {
        path: '/jnt/modify/:id',
        name: 'modify',
        component: () =>
            import ('../views/jnt/Modify.vue'),
        meta: { authc: true }
    },
    {
        path: '/jnt/center/msg',
        name: 'msg',
        component: () =>
            import ('../views/jnt/center/Msg.vue'),
        meta: { authc: true }
    },
    {
        path: '/jnt/center/feedback',
        name: 'feedback',
        component: () =>
            import ('../views/jnt/center/Feedback.vue'),
        meta: { authc: true }
    },
    {
        path: '/jnt/center/feedhistory',
        name: 'feedhistory',
        component: () =>
            import ('../views/jnt/center/FeedHistory.vue'),
        meta: { authc: true }
    },
    // {
    //     path: '/jnt/contact',
    //     name: 'contact',
    //     component: () =>
    //         import ('../views/jnt/Contact.vue'),
    //     meta: { authc: true }
    // },
    {
        path: '/jnt/center/bind',
        name: 'bind',
        component: () =>
            import ('../views/jnt/center/Bind.vue'),
        meta: { authc: true }
    },
    {
        path: '/jnt/center/modify',
        name: 'modify',
        component: () =>
            import ('../views/jnt/center/Modify.vue'),
        meta: { authc: true }
    },
    {
        path: '/jnt/center/setting',
        name: 'setting',
        component: () =>
            import ('../views/jnt/center/Setting.vue'),
        meta: { authc: true }
    },
    {
        path: '/jnt/center/agreement',
        name: 'agreement',
        component: () =>
            import ('../views/jnt/center/Agreement.vue'),
        meta: { authc: true }
    },
    {
        path: '/jnt/center/about',
        name: 'about',
        component: () =>
            import ('../views/jnt/center/About.vue'),
        meta: { authc: true }
    },
    {
        path: '/jnt/create',
        name: 'create',
        component: () =>
            import ('../views/jnt/Create.vue'),
        meta: { authc: true }
    },

    {
        path: '/jnt/center/creat',
        name: 'myCreat',
        component: () =>
            import ('../views/jnt/center/Creat.vue'),
        meta: { authc: true }
    },
    {
        path: '/jnt/center/collect',
        name: 'myCreat',
        component: () =>
            import ('../views/jnt/center/Collect.vue'),
        meta: { authc: true }
    },
    {
        path: '/jnt/center/friend',
        name: 'friend',
        component: () =>
            import ('../views/jnt/center/Friend.vue'),
        meta: { authc: true }
    },
    {
        path: '/jnt/center/modify',
        name: 'modify',
        component: () =>
            import ('../views/jnt/center/Modify.vue'),
        meta: { authc: true }
    },
    {
        path: '/jnt/mourns/:type',
        name: 'mourns',
        component: () =>
            import ('../views/jnt/Mourns.vue'),
        meta: { authc: true }
    },
    {
        path: '/jnt/help',
        name: 'help',
        component: () =>
            import ('../views/jnt/center/Help.vue'),
        meta: { authc: true }
    },
    {
        path: '/jnt/help/:id',
        name: 'view',
        component: () =>
            import ('../views/jnt/center/View.vue'),
        meta: { authc: true }
    },
    {
        path: '/jnt/list/:type',
        name: 'list',
        component: () =>
            import ('../views/jnt/List.vue'),
        meta: { authc: true }
    },

    {
        path: '/frame/about',
        component: () =>
            import ('@/views/frame/about.vue'),
    },
    {
        path: '/frame/myyq',
        component: () =>
            import ('@/views/frame/myyq.vue'),
    },
    {
        path: '/frame/sqqy',
        component: () =>
            import ('@/views/frame/sqqy.vue'),
    },
    {
        path: '/frame/service',
        component: () =>
            import ('@/views/frame/service.vue'),
    },
    {
        path: '/frame/dynamic',
        component: () =>
            import ('@/views/frame/dynamic.vue'),
    },
    {
        path: '/frame/natural',
        component: () =>
            import ('@/views/frame/natural.vue'),
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
})

export default router